import HeaderNavigation from './HeaderNavigation/HeaderNavigation';
import FooterNavigation from './FooterNavigation/FooterNavigation';

export default {
  Header: HeaderNavigation,
  Footer: FooterNavigation,
};
